<template>

    <div class="dashboard">
        <p class="bg-ss-gray">{{ lang('all.hallo') }} <strong>{{ name }}</strong></p>
        <p class="bg-ss-gray">{{ lang('all.vanaf_je_account_dashboard_kun_je_je_recente_beste') }}</p>
    </div>

</template>

<script>

import MyAccountLayout from "../../../Shared/Auth/MyAccount/Layout";

export default {

    layout:MyAccountLayout,

    metaInfo: {
        title: 'Mijn account'
    },

    name:'AuthMyAccountIndex',

    props: {
        name: {
            required:true,
        },
    },

}

</script>
